import React, { createContext, useState, ReactNode } from "react";

type AuthDataType = {
  email: string | undefined;
  accessToken: string | undefined;
  roles: string[] | undefined;
  impersonatedBy: string | undefined;
};

interface AuthContextType {
  auth: AuthDataType;
  setAuth: React.Dispatch<
    React.SetStateAction<AuthDataType>
  >;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

interface AuthProviderProps {
  children: ReactNode;
}

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const storedAuthJson = localStorage.getItem("auth") ?? "{}";
  const { email, accessToken, roles = [], impersonatedBy } = JSON.parse(storedAuthJson);
  const [auth, setAuth] = useState<AuthDataType>({ email, accessToken, roles, impersonatedBy });

  return (
    <AuthContext.Provider value={{ auth, setAuth }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
